import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { toast } from 'sonner';
import { updateSitemapFile } from '@/utils/sitemapUtils';
import { BLOG_POSTS } from '@/mock';

const SitemapUpdater = () => {
    const [sitemap, setSitemap] = useState('');
    const [loading, setLoading] = useState(false);

    const generateSitemap = () => {
        setLoading(true);
        try {
            const newSitemap = updateSitemapFile();
            setSitemap(newSitemap);
            toast.success('Sitemap обновлен на основе реальных статей!');
        } catch (error) {
            console.error('Error:', error);
            toast.error('Ошибка генерации sitemap');
        } finally {
            setLoading(false);
        }
    };

    const copyToClipboard = () => {
        navigator.clipboard.writeText(sitemap);
        toast.success('Скопировано в буфер обмена');
    };

    const downloadSitemap = () => {
        const blob = new Blob([sitemap], { type: 'application/xml' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'sitemap.xml';
        a.click();
        URL.revokeObjectURL(url);
    };

    return (
        <div style={{ padding: '20px', maxWidth: '1200px' }}>
            <h1>🔄 Sitemap Updater</h1>
            <p>Обновление sitemap на основе реальных статей из проекта</p>

            <div className="mb-6">
                <h3>Текущие статьи в проекте:</h3>
                <div className="grid gap-2 mt-2">
                    {BLOG_POSTS.map((post, index) => (
                        <div key={index} className="p-3 border rounded bg-gray-50">
                            <p><strong>{post.title}</strong></p>
                            <p className="text-sm text-gray-600">
                                URL: /article/{post.id}<br/>
                                Дата: {post.date}
                            </p>
                        </div>
                    ))}
                </div>
            </div>

            <div className="mb-4 flex gap-2">
                <Button onClick={generateSitemap} disabled={loading}>
                    {loading ? 'Генерация...' : '🔄 Обновить Sitemap'}
                </Button>
                
                {sitemap && (
                    <>
                        <Button onClick={copyToClipboard} variant="outline">
                            📋 Копировать
                        </Button>
                        <Button onClick={downloadSitemap} variant="outline">
                            💾 Скачать
                        </Button>
                    </>
                )}
            </div>

            {sitemap && (
                <Card>
                    <CardHeader>
                        <CardTitle>Обновленный Sitemap</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="mb-4">
                            <p><strong>Всего URL:</strong> {(sitemap.match(/<loc>/g) || []).length}</p>
                            <p><strong>Размер:</strong> {sitemap.length} символов</p>
                        </div>
                        
                        <details open>
                            <summary>Показать XML</summary>
                            <div className="mt-4">
                                <pre className="bg-gray-50 p-4 rounded text-xs overflow-auto max-h-96 whitespace-pre-wrap font-mono border">
                                    {sitemap}
                                </pre>
                            </div>
                        </details>
                        
                        <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded">
                            <p className="text-blue-800 text-sm">
                                <strong>💡 Инструкция:</strong> Скопируйте этот XML и замените содержимое файла 
                                <code className="bg-blue-100 px-1 rounded">public/sitemap.xml</code>
                            </p>
                        </div>
                    </CardContent>
                </Card>
            )}
        </div>
    );
};

export default SitemapUpdater;
